export default "__VITE_ASSET__DHsrXO4c__"